import Dexie from 'dexie'
import { EmailsTableType, emailsSchema } from './tables/emails'

type DexieTablesType = EmailsTableType

type DexieType<T extends DexieTablesType = DexieTablesType> = Dexie & T

const database = new Dexie('email-editor-db') as DexieType

const schema = { ...emailsSchema }

database.version(1).stores(schema)

export default database
